(() => {
    // Variables
    const monogramValue = [];

    // Elements


    const cartItems = JSON.parse(document.getElementById('cart-items').textContent);
    const addonProducts = JSON.parse(document.getElementById('addon-products').textContent);
    const cartItemIds = cartItems.items.map(item => item.product_id);
    const openAddonPopupButtons = document.querySelectorAll('.js-addon-popup-button');
    const clearMonogramBtn = document.querySelectorAll('.addon-monogram-text-input__clear');
 const monogramPlaceholder = document.querySelector('.customization-editor__preview-chars');
    const removeMonogramBtn = document.querySelectorAll('.addon-customization-monogram__preview-link--remove');

    removeMonogramBtn.forEach(button => {
        button.addEventListener('click', () => {
            resetAll();
        });
    });

    clearMonogramBtn.forEach(button => {
        button.addEventListener('click', () => {
            resetTypo();
        });
    });


    let selectedVariant = null;
    const addonProductData = addonProducts.map(product => {
        const addonProductIds = product.inheriting_products.map(variant => variant.split("/").pop().trim());

        return {
            title: product.title,
            ids: addonProductIds,
            inCart: addonProductIds.some(id => cartItemIds.includes(Number(id))),
        }
    });


    /*
    * Listen for cart updates
    */
    function initCartListener() {

        if (typeof subscribe !== "function") return false;
        const unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const cartData = event?.cartData || event?.data?.cartData || event?.cart || null;
            if (cartData.product_id) {
                resetAll();
                for (const product of addonProductData) {
                    if (product.ids.includes(cartData.product_id.toString())) {

                        product.inCart = true;
                        openAddonPopupButtons.forEach(button => {
                            if (button.dataset.addonTitle === product.title) {
                                button.classList.add('in-cart');
                            }
                        });
                    }
                }
            }
            if (cartData.items_removed) {

                for (const product of addonProductData) {
                    if (product.ids.includes(cartData.items_removed[0]?.product_id?.toString())) {
                        product.inCart = false;
                        openAddonPopupButtons.forEach(button => {
                            if (button.dataset.addonTitle === product.title) {
                                button.classList.remove('in-cart');
                            }
                        });
                    }

                }
                return true;
            }
        });
    }


    let addonItemData = null;
    let addonItem = null;
    let addOnActiveItem = null;

    const popupColorPickerButtons = document.querySelectorAll('.js-popup .swatch-input__label');

    /*
    * Open addon popup
    */
    openAddonPopupButtons.forEach(button => {

        const isInCartCheck = addonProductData.find(product => product.title === button.dataset.addonTitle);

        if (isInCartCheck.inCart) {
            button.classList.add('in-cart');
        }
        else {
            button.classList.remove('in-cart');
        }
        button.addEventListener('click', (event) => {
            event.preventDefault();
            resetAll();
            addonItem = button.dataset.addonItem;
            const addonItemScript = document.getElementById(`addon-item-${addonItem}`);
            addonItemData = JSON.parse(addonItemScript.textContent);
            
            
                        const addonActiveItemScript = document.getElementById(`addon-active-item-${addonItem}`);
            addonActiveItem = JSON.parse(addonActiveItemScript.textContent);
            
            selectedVariant = addonActiveItem;

            const productFormsToHide = document.querySelectorAll('.product-form-addon');
            productFormsToHide.forEach(form => {

                  if (form.id === `addon-product-form-${selectedVariant.id}`) {
                    form.style.display = 'block';
                } else {
                    form.style.display = 'none';
                }
            });

            popupColorPickerButtons.forEach(button => {
                const itemData = addonItemData.find(item => item.id === Number(button.dataset.optionValueId));

                if (itemData) {
                    if (itemData.id === addonActiveItem.id) {

                    }
                    if (!itemData.available) {
                        button.style.display = 'none';
                    }
                }

            });
        });
    });

    /*
    * Handle monogram button clicks
    */
    const addonMonogramButtons = document.querySelectorAll('.js-addon-monogram-button');
    addonMonogramButtons.forEach(button => {
        button.addEventListener('click', (event) => {

            event.preventDefault();
            resetAll();
            const addonMonogramContainer = document.querySelector('.js-addon-monogram-container');
            addonMonogramContainer.style.display = 'block';

            const productFormsToHide = document.querySelectorAll('.product-form-addon');
            productFormsToHide.forEach(form => {
                if (form.dataset.product.split("/")[0] === selectedVariant.title.split("/")[0]) {
                    form.style.display = 'none';
                }
            });
        });
    });

    /*
    * Handle monogram input changes
    */
    const addonMonogramInputs = document.querySelectorAll('.addon-monogram-text-input__field');
    const addMonogramBtn = document.querySelector('.js-monogram-addon-add-btn');
    if (addonMonogramInputs.length) {
        addonMonogramInputs.forEach((input, index) => {
            input.addEventListener('input', function () {
                const allowedChars = /[^a-zA-Z&\-.]/g;
                this.value = this.value.replace(allowedChars, '');
                monogramValue[index] = this.value.toUpperCase();
                if (this.value.length) {
                    const nextInput = addonMonogramInputs[index + 1 >= addonMonogramInputs.length ? 0 : index + 1];
                    nextInput.focus();
                    nextInput.select();
                }
                enableAddMonogramBtn();
typeToPlaceholder();
            });
        });
    }


    const atcFormMonogram = document.querySelectorAll('#addon-monogram-id');
    const customizationMonogram = document.querySelectorAll('#addon-monogram-preview');
    const customizationPlaceholder = document.querySelectorAll('.addon-monogram-customization-monogram__preview-value');
    if (addMonogramBtn) {
        addMonogramBtn.addEventListener('click', () => {

            const bundleParent = selectedVariant.id;
            const bundleId = new Date().valueOf();

            const monogramId = atcFormMonogram[0].dataset.addonMonogramId;

            customizationMonogram.forEach(monogram => {
                monogram.classList.remove('hidden');
            });
            customizationPlaceholder.forEach(placeholder => {
                placeholder.textContent = monogramValue.join('');
            });

            const formsToHide = document.querySelectorAll('.js-addon-monogram-container');
            formsToHide.forEach(form => {


                form.style.display = 'none';
            });

            const productFormsToHide = document.querySelectorAll('.product-form-addon');

            productFormsToHide.forEach(form => {
                if (form.id === `addon-product-form-${selectedVariant.id}`) {
                    form.style.display = 'block';
                }
            })

            atcFormMonogram.forEach(form => {

                if (Number(form.dataset.parentProductId) === selectedVariant.id) {

                    form.innerHTML = `
                    <input type="hidden" name="properties[_Monogram]" value="${monogramValue.join('')}">
                    <input type="hidden" name="properties[_bundleId]" value="${bundleId}">
                    <input type="hidden" name="properties[_bundleParent]" value="${bundleParent}">
                    <input type="hidden" name="properties[_hashParent]" value="${bundleId}">
                    <input type="hidden" name="properties[_customized]" value="Monogram">      
                    <input type="hidden" name="items[0][id]" value="${form.dataset.addonMonogramId}">
                    <input type="hidden" name="items[0][quantity]" value="1">
                    <input type="hidden" name="items[0][properties][Monogram]" value="${monogramValue.join('')}">
                    <input type="hidden" name="items[0][properties][_bundleId]" value="${bundleId}">
                    <input type="hidden" name="items[0][properties][_hashChild]" value="${bundleId}">
                    <input type="hidden" name="items[0][properties][_excludeFromReturns]" value="true">
                `;
                }
            });

        });
    }

    function enableAddMonogramBtn() {
        if (monogramValue.length) {
            addMonogramBtn.removeAttribute('disabled');
        } else {
            addMonogramBtn.addAttribute('disabled', true);
        }
    }

    /*
    * Handle color picker button clicks
    */
    popupColorPickerButtons.forEach(button => {

        button.addEventListener('click', (event) => {

            event.preventDefault();
            event.stopPropagation();
            resetAll();
            const selectedVariantId = button.dataset.optionValueId;
            const input = document.getElementById(button.htmlFor);
            const selectedSwatchValue = button.closest(`.product-form__input`).querySelector('[data-selected-value]');
            
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = input.value;
            selectedVariant = addonItemData.find(variant => variant.id === Number(selectedVariantId));
            
            const checkedInput = button.parentElement.querySelector('input[checked]');
            if (checkedInput) checkedInput.removeAttribute('checked');
            input.setAttribute('checked', 'checked');
            const addonItemImage = document.getElementById(`addon-item-image-${addonItem}`);
            addonItemImage.src = selectedVariant.featured_image;
            const allVariantForms = document.querySelectorAll('.product-form-addon');

            const filterAddonForms = addonItemData.filter(variant => variant.available === true);

            allVariantForms.forEach(form => {
              
              
                if (form.dataset.product === addonActiveItem.title) {

                    form.style.display = 'none';
                }
            });
            const variantForm = document.getElementById(`addon-product-form-${selectedVariant.id}`);
            variantForm.style.display = 'block';
            //variantIdInput.value = selectedVariant.id;
        });
    });

    function resetAll() {

        monogramValue.length = 0;
        addonMonogramInputs.forEach((input) => {
            input.value = '';
        });
        atcFormMonogram.forEach(form => {
            form.innerHTML = '';
        });
        if (addMonogramBtn) {
            addMonogramBtn.removeAttribute('disabled');
        }

        removeMonogramBtn.forEach(button => {
            button.classList.add('hidden');
        });
        customizationMonogram.forEach(monogram => {
            monogram.classList.add('hidden');
        });
        customizationPlaceholder.forEach(placeholder => {
            placeholder.textContent = '';
        });

        const formsToHide = document.querySelectorAll('.js-addon-monogram-container');
        formsToHide.forEach(form => {
            form.style.display = 'none';
        });

    }

    function resetTypo() {
        const formsToHide = document.querySelectorAll('.js-addon-monogram-container');
        formsToHide.forEach(form => {
            form.style.display = 'none';
        });

        const productFormsToHide = document.querySelectorAll('.product-form-addon');
        productFormsToHide.forEach(form => {
            if (form.id === `addon-product-form-${selectedVariant.id}`) {
                form.style.display = 'block';
            }
        })
    }

        function typeToPlaceholder() {
        monogramPlaceholder.textContent = monogramValue.join('');
    }

    initCartListener();
})();